<template>
  <div>
    <!-- MODALE PER LA PRIVACY -->
    <b-modal v-model="privacy_modal_show" size="xl"
              :no-close-on-esc="true"
              :no-close-on-backdrop="true"
              :scrollable="true"
              :hide-header="true"
              :hide-footer="true">
      <b-row>
        <b-col>
          <TestoPrivacy/>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <h3>ACCETTAZIONE PRIVACY</h3>
          <p>Il/la sottoscritto/a, avendo preso visione delle informazioni relative al trattamento dei dati personali ai sensi dell' art. 13 del Reg. UE 679/2016, presta il suo consenso:</p>
          <!-- Form per l'accettazione della privacy -->
          <b-form @submit.prevent="privacyForm">
            <!-- Accettazione privacy servizio - campo richiesto -->
            <b-form-group id="group-pv-servizio">
              <b-form-checkbox
                  id="pv-servizio"
                  name="pv-servizio"
                  :value="true"
                  :unchecked-value="false"
                  v-model="form.privacy_servizio"
                  required>
                <span class="font-weight-bold">Al trattamento dei dati particolari per i fini di erogazione del servizio indicati nella suddetta informativa</span>
              </b-form-checkbox>
            </b-form-group>
            <!-- Accettazione privacy dati personali - campo opzionale -->
            <b-form-group id="group-pv-dati-pers">
              <b-form-checkbox
                  id="pv-dati-pers"
                  name="pv-dat-pers"
                  :value="true"
                  :unchecked-value="false"
                  v-model="form.privacy_dati_personali">
                <span class="font-weight-bold">Al trattamento dei dati personali per ricevere comunicazioni di natura commerciale e/o promozionale</span>
              </b-form-checkbox>
            </b-form-group>
            <!-- Firma utente -->
            <b-form-group id="group-firma"
              label="Firma"
              label-class="font-weight-bold"
              label-for="signature">
              <b-input-group>
                <b-form-input
                  id="signature"
                  v-model="form.signature"
                  placeholder="Scrivi il tuo nome"
                  required
                ></b-form-input>
              </b-input-group>
            </b-form-group>

            <!-- Pulsante di accettazione della privacy -->
            <div class="text-center">
              <b-button type="submit" variant="primary" class="mr-1" :disabled="pv_btn_diabled">
                Per continuare è necessario accettare la privacy.
              </b-button>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>

    <!-- MODALE PER IL DECALOGO SULLA SICUREZZA -->
    <b-modal v-model="decalogue_modal_show" size="xl"
              :no-close-on-esc="true"
              :no-close-on-backdrop="true"
              :scrollable="true"
              :hide-header="true"
              :hide-footer="true">
      <b-row>
        <b-col>
          <TestoDecalogoSicurezza/>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <!-- Form per l'accettazione del decalogo digitale -->
          <b-form @submit.prevent="decalogueForm">
            <!-- Accettazione codice di comportamento digitale - campo richiesto -->
            <b-form-group id="group-pv-servizio">
              <b-form-checkbox
                  id="dc-sicurezza"
                  name="dc-sicurezza"
                  :value="true"
                  :unchecked-value="false"
                  v-model="form.decalogo_sicurezza"
                  required>
                  <div class="text-justify">
                    Dichiaro di aver preso visione e di aver ben compreso il contenuto del presente documento <b>“CODICE DI COMPORTAMENTO DIGITALE”</b>,
                    impegnandomi a darne puntuale attuazione nella consapevolezza che il mancato rispetto di tali comportamenti non permetterà di
                    garantire la sicurezza dei dati e delle informazioni da parte di Welfarebit.
                  </div>
                </b-form-checkbox>
            </b-form-group>
            <!-- Pulsante di accettazione del decalogo -->
            <div class="text-center">
              <b-button type="submit" variant="primary" class="mr-1" :disabled="dc_btn_diabled">
                Per continuare è necessario accettare il codice di comportamento digitale
              </b-button>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>


<script>
import TestoPrivacy from '@/components/TestoPrivacy.vue'
import TestoDecalogoSicurezza from '@/components/TestoDecalogoSicurezza.vue'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'UserConditions',
  data() {
    return {
      // Flag per visualizzare le modali di privacy e decalogo
      privacy_modal_show: false,
      decalogue_modal_show: false,

      // I dati da inviare al backend
      form : {
        privacy_servizio : false,
        privacy_dati_personali : false,
        decalogo_sicurezza : false,
        signature : null
      },

      // Flag per gestire l'abilitazione dei pulsanti di submit
      pv_btn_diabled : false,
      dc_btn_diabled : false
    }
  },
  methods : {
    /**
     * Mostra la finestra di privacy e nasconde quella del decalogo
     */
    show_privacy : function () {
      this.privacy_modal_show = true;
      this.decalogue_modal_show = false;
    },
    /**
     * Mostra la finestra del decalogo e nasconde quella della privacy
     */
    show_decalogue : function () {
      this.privacy_modal_show = false;
      this.decalogue_modal_show = true;
    },

    /**
     * Chiude tutte le finestre modali
     */
    close_all : function () {
      this.privacy_modal_show = false;
      this.decalogue_modal_show = false;
    },

    /**
     * Metodo richiamato quando si accettano i termini della privacy.
     */
    privacyForm : function () {

      // Disabilito il pulsante di submit per evitare doppi click
      this.pv_btn_diabled = true;

      // Se anche la parte del decalogo sulla sicurezza è stata accettata
      // allora eseguo il submit dei dati e chiudo la modale, altrimenti
      // apro la modale del decalogo. Ciò può avvenire se dobbiamo riproporre
      // la privacy agli utenti ma non il decalogo.
      if ( this.form.decalogo_sicurezza === true ){
        this.submit_dati();
      } else {
        this.show_decalogue();
      }
    },

    /**
     * Metodo richiamato quando si accettano i termini del decalogo sulla sicurezza.
     */
    decalogueForm : function () {

      // Disabilito il pulsante di submit per evitare doppi click
      this.dc_btn_diabled = true;

      // Se accetto questa parte, quella della privacy è sicuramente ok perchè
      // valutata per prima e visualizzata per prima al created dell'elemento,
      // posso quindi direttamente postare i dati.
      this.submit_dati();
    },

    /**
     * Invia i dati una volta che l'utente ha visionato sia
     * la privacy che il decalogo sulla sicurezza
     */
    submit_dati : function () {

      axios.post( apiUrl.welfareapi.user_privacy, this.form  )
      .then ( ( response ) => {
        // Dati della privacy salvati correttamente chiudiamo tutte le modali
        this.close_all();
      })
      .catch( ( error ) => {
        // Errore!
        generalLib.backend_error_message_box( this, error.response.data );
      });

    }
  },
  /**
   * Alla creazione dell'elemento controlliamo lo stato della privacy
   * e agiamo nei seguente modi:
   *  - non c'è una entry per la privacy: l'utente non ha mai accettato nulla, partiamo
   *    con la modale della privacy aperta
   * -  c'è una entry per la privacy ma il flag dei termini di servizio è false, l'utente
   *    deve eccetarli per questo ripartiamo con la modale della privacy aperta.
   * -  c'è una entry per la privacy e il flag dei termini di servizio è true, controllo
   *    quindi il flag del decalogo sulla sicurezza, se è false apro la modale del decalogo.
   */
  created : function () {
    axios.get( apiUrl.welfareapi.user_privacy )
    .then ( ( response ) => {

      // inizializziamo i dati interni con quelli ricevuti dal backend
      this.form.privacy_servizio = response.data.privacy_servizio;
      this.form.privacy_dati_personali = response.data.privacy_dati_personali;
      this.form.decalogo_sicurezza = response.data.decalogo_sicurezza;
      this.form.signature = response.data.signature;

      // Una entry per la privacy di questo utente siste già, controlliamo il flag
      // dei termini di servizio, il quale è primario rispetto al decalogo di sicurezza
      // se è false dobbiamo far vedere la finestra di accettazione della privacy
      if ( this.form.privacy_servizio === false ){
        this.show_privacy();
      }

      // Se il flag dei termini di servizio è true la privacy è già ok, passiamo
      // direttamente a vedere il flag del decalogo sulla sicurezza, se è false allora
      // manca lui all'appello.
      if ( this.form.privacy_servizio === true && this.form.decalogo_sicurezza === false ){
        this.show_decalogue();
      }

      // Altrimenti l'utente ha fatto tutto, non devo visualizzare nulla

    })
    .catch ( ( error ) => {
      // Se lo status è 404 ( not found ) non è stata trovata la entry
      // per l'utente e quindi la privacy deve essere accettata
      if ( error.response.status === 404 ) {
        this.show_privacy();
      } else {
        // Altrimenti abbiamo un altro errore che notifichiamo all'utente
        generalLib.backend_error_message_box( this, error.response.data );
      }
    });
  },
  components: {
    TestoPrivacy,
    TestoDecalogoSicurezza
  }
}
</script>


<style scoped></style>